import React from 'react';
import PropTypes from 'prop-types';
import UserIcon from 'core/icons/UserIcon';
import { UserBtn, BtnText } from './bubbleStyles';

const Trigger = ({ text, Img, ...props }) => (
	<UserBtn { ...props }>
		{Img ? Img :
			<UserIcon stroke="currentColor" />
		}
		{text && (
			<BtnText>{ text }</BtnText>
		)}
	</UserBtn>
);

Trigger.propTypes = {
	text: PropTypes.string,
	Img: PropTypes.element,
};

export default Trigger;
